import { UserAccessLevel } from "V2.0/models/UserProfile";

function useAgentAssignment(conversation, user) {
  const { status, humanAgentAssignmentSettings } = conversation;

  const isConversationActive = status === "ACTIVE";
  const isActiveUserCompanyOwner =
    user?.userAccessLevel === UserAccessLevel.WHITELABELOWNER;

  const isHumanAgentAssigned = Boolean(
    humanAgentAssignmentSettings?.humanAgentAssigned,
  );

  const isActiveUserTheHumanAgent =
    isHumanAgentAssigned &&
    humanAgentAssignmentSettings.humanAgentAssigned?.email === user.email &&
    user?.userAccessLevel != UserAccessLevel.WHITELABELVIEWER;

  const allowActiveUserToSendMessage =
    isHumanAgentAssigned && isActiveUserTheHumanAgent && isConversationActive;

  const allowActiveUserToReassign =
    isHumanAgentAssigned &&
    isConversationActive &&
    (isActiveUserTheHumanAgent || isActiveUserCompanyOwner);

  const allowActiveUserToResolve =
    isHumanAgentAssigned &&
    isConversationActive &&
    (isActiveUserTheHumanAgent || isActiveUserCompanyOwner);

  const allowActiveUserToAssign = !isHumanAgentAssigned && isConversationActive;

  return {
    isConversationActive,
    isActiveUserCompanyOwner,
    isHumanAgentAssigned,
    allowActiveUserToAssign,
    allowActiveUserToReassign,
    allowActiveUserToResolve,
    allowActiveUserToSendMessage,
  };
}

export default useAgentAssignment;
